/**
 * SessionIDUtil - Utility for managing the application session ID
 * The session ID remains consistent for the duration of the application usage
 * and is used to prevent duplicate actions from cable connections.
 */
import { v4 as uuidv4 } from 'uuid';

let _sessionID = null;

/**
 * Get the current session ID or create a new one if it doesn't exist
 * @returns {string} The session ID
 */
export const getSessionID = () => {
  if (!_sessionID) {
    // Try to get from sessionStorage first for persistence across page refreshes
    const storedID = sessionStorage.getItem('appSessionID');
    if (storedID) {
      _sessionID = storedID;
    } else {
      // Generate a new session ID
      _sessionID = uuidv4();
      // Store in sessionStorage for persistence
      sessionStorage.setItem('appSessionID', _sessionID);
    }
  }
  
  return _sessionID;
};

/**
 * Check if the provided session ID matches the current session
 * @param {string} sessionID - The session ID to check
 * @returns {boolean} True if it matches the current session ID
 */
export const isCurrentSession = (sessionID) => {
  return sessionID === getSessionID();
};

export default {
  getSessionID,
  isCurrentSession
};
